var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-badge',{attrs:{"color":"warning","dot":""}},[_vm._t("activator",null,{"on":on})],2)]}}],null,true)},[_c('span',[_vm._v(" "+_vm._s(_vm.tooltip)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }